// Example tenant build for INC-020 (demo parametrizable, agnóstica a la empresa dueña de Caimán).
// Selected via `ng build --configuration demo` / `npm run build:demo` (see angular.json ->
// projects.matngular.architect.build.configurations.demo).
//
// To spin up a *new* tenant/demo:
//   1. Copy this file to environment.<tenant>.ts and fill in its apiUrl/file/branding.
//   2. Drop that tenant's logo/sidebar-bg assets under src/assets/img (or a subfolder) and
//      point branding.* at them.
//   3. Add a "<tenant>" configuration in angular.json (build + serve) with a fileReplacements
//      entry swapping environment.ts -> environment.<tenant>.ts, and, if the tenant needs its
//      own primary/secondary colors, another entry swapping
//      src/assets/sass/scss/_brand.scss -> src/assets/sass/scss/_brand.<tenant>.scss
//      (copy _brand.demo.scss as a starting point).
//   4. `npm run build:<tenant>` locally and commit the resulting dist/ on that tenant's deploy
//      branch, same as staging/production today.

import { Branding } from "./branding.model";

// Generic placeholder logos/background under assets/img/demo — swap them for the tenant's
// actual brand assets before using this for a real demo/sale.
const branding: Branding = {
  companyName: "Demo",
  logoUrl: "assets/img/demo/logo.svg",
  logoDarkUrl: "assets/img/demo/logo-dark.svg",
  logoLoginUrl: "assets/img/demo/logo-login.svg",
  sidebarBackgroundUrl: "assets/img/demo/sidebar-bg.svg",
};

export const environment = {
  production: false,
  apiUrl: "https://api-demo.sistemaproduccion.com.ar/v1",
  file: "https://api-demo.sistemaproduccion.com.ar",
  // TODO(INC-020): planSearchUrl / plan3dUrl point at Caimán's own factory LAN (192.168.0.4)
  // and are meaningless for another tenant's network. Leave blank or point at the tenant's
  // own plan-search/3D-viewer host once one exists — see gap #2 in
  // .claude/multitenant-roadmap.md.
  planSearchUrl: "http://192.168.0.4/tcsearch/plano60.asp",
  plan3dUrl: "http://192.168.0.4/jt/",
  featureFlags: {
    workplanTasks: true,
  },
  branding,
};
